import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { AuthService } from '../services/authentication.services';
import { NavigateUserToReturnedURL, UserIsAuthenticated } from '../store/authentication.actions';
import { IUserModel } from '../../users/models/user.model';
import { isAuthenticated } from '../store/authentication.reducer';
import { IRole } from 'src/app/permissions/models/role.model';
import { MatomoService } from 'src/app/core/services/matomo.service';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedGuard {
  private store = inject(Store);
  private authService = inject(AuthService);
  private router = inject(Router);
  private matomoService = inject(MatomoService);

  canActivate(): Observable<boolean> {
    const token = sessionStorage.getItem(environment.authTokenName);
    if (!token) {
      this.router.navigateByUrl('authentication').then(() => false);
    }

    return this.store
      .select(isAuthenticated)
      .pipe(mergeMap((isAuthenticatedState) => (isAuthenticatedState ? of(true) : this.validateUserViaServer())));
  }

  validateUserViaServer(): Observable<boolean> {
    return this.authService.isUserAuthenticated().pipe(
      map((data: { user: IUserModel; role: IRole; effectiveRole: IRole }) => {
        this.store.dispatch(UserIsAuthenticated(data));
        this.store.dispatch(NavigateUserToReturnedURL());
        if (data.user._id) {
          this.matomoService.trackEvent('System log', `System log signin`, `System log signin ${data.user._id}`);
        }
        return true;
      }),
      catchError(() => this.router.navigateByUrl('authentication').then(() => false))
    );
  }
}
